import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { KkmsDetailsService } from '../../../core/services/kkm-details.service';
import { OrganizationApiService } from '../../../core/modules/organization/organization-api.service';
import { TicketApiService } from '../../../core/modules/tickets/ticket-api.service';
import { RetailPlacesApiService } from '../../../core/modules/retail-places/retail-places-api.service';

@Component({
  selector: 'tax-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.sass'],
})

export class ReportComponent implements OnInit, OnDestroy {
  private subscription: Subscription[] = [];
  // @ts-ignore
  reportId: string;
  model: any;
  organisation: any;
  kkm: any;
  retailPlace: any;
  isXReport: boolean = true;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private ticketApiService: TicketApiService,
    private organizationApiService: OrganizationApiService,
    private retailPlaceApiService: RetailPlacesApiService,
    private kkmsDetailsService: KkmsDetailsService,
  ) { }

  ngOnInit(): void {
    let kkmId: string;
    // @ts-ignore
    this.isXReport = this.router.url.includes('xreport');
    // @ts-ignore
    this.reportId = this.activatedRoute.snapshot.paramMap.get('rid');
    // @ts-ignore
    kkmId = this.activatedRoute.snapshot.paramMap.get('id');

    this.subscription.push(this.kkmsDetailsService.getKkm(Number(kkmId)).subscribe(
      response => this.kkm = response,
      () => {},
      () => {
        this.subscription.push(this.retailPlaceApiService.fetchRetailPlace(Number(this.kkm.retailPlaceId)).subscribe(
          rpResponse => this.retailPlace = rpResponse,
        ));
      },
    ));

    this.subscription.push(this.organizationApiService.fetchOrganization().subscribe(
      response => this.organisation = response,
    ));
    if (this.reportId) {
      this.subscription.push(this.ticketApiService.fetchReport(this.reportId).subscribe(
        response => this.model = response,
      ));
    }
  }

  ngOnDestroy(): void {
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }
}
